import * as amplitude from '@amplitude/analytics-browser';

export type EventParamsType = Record<string, string | undefined>;

const trackEvent = (event, eventParams?: EventParamsType) => {
  // Verified production for creating events in GTAG and Amplitude.
  if (process.env.NEXT_PUBLIC_API_URL === 'https://api.bid2board.com') {
    const userId = localStorage.getItem('userId');

    // create event in GTAG
    if (Boolean(window?.gtag) && typeof window?.gtag !== 'undefined') {
      window.gtag('event', event, {
        ...eventParams,
        user_ID: userId,
      });
    }

    // create event in Amplitude
    amplitude.track(event, eventParams);
  }
};

export default trackEvent;
